import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Chip, Skeleton } from '@mint-lib/tw-components';

import { getSchedulerStatus } from '../../../../helpers/queryScheduleStatus.js';
import { ScheduleTableType } from '../../../../types/queryScheduler.js';

const StatusCell = ({ data }: ICellRendererParams<ScheduleTableType>) => {
  if (data?.__isSkeleton) {
    return <Skeleton />;
  }

  if (!data?.status) {
    return null;
  }

  const currStatus = getSchedulerStatus(data.status);

  return (
    <div className="flex h-full items-center">
      <Chip
        color={currStatus.color}
        size="small"
        variant="outline"
        className="capitalize"
      >
        {currStatus.label}
      </Chip>
    </div>
  );
};

export { StatusCell };
